var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2023-07-20
 * @brief SEI 설비유형 Management  개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
import { useAsync } from "react-async";
// recoil
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { reLoad, reLoadPage, userInfoLoginState } from "../../../../recoil/userState";
//utils
import * as CONST from "../../../../utils/Const";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../utils/commUtils";
import { alertState } from "../../../../recoil/assessmentState";
import { checkSheetState, loadingBoxState, spgState } from "../../../../recoil/menuState";
import { useTrans } from "../../../../utils/langs/useTrans";
function SpgDefalutUpdate(props) {
    const t = useTrans();
    //recoli
    const userInfo = useRecoilValue(userInfoLoginState);
    const [checksheet, setCheckSheet] = useRecoilState(checkSheetState);
    const [spgs, setSpgs] = useRecoilState(spgState);
    const setReload = useSetRecoilState(reLoad);
    const [reLoadPages, setReloadPages] = useRecoilState(reLoadPage);
    const [alerts, setAlerts] = useRecoilState(alertState);
    const reload = useRecoilValue(reLoad);
    const setRecoilIsLoadingBox = useSetRecoilState(loadingBoxState);
    //props
    const { checksheetName, setWorkMode } = props;
    //
    const [errorList, setErrorList] = useState([]);
    const [spgName, setSpgName] = useState("");
    const [spgNameEn, setSpgNameEn] = useState("");
    const [elecinfo, setElecinfo] = useState([]);
    const [isActive, setIsActive] = useState(false);
    const [spgGroupItem, setSpgGroupItem] = useState([]);
    const [spgGroup, setSpgGroup] = useState(null);
    //기본유형 spg Tree
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/spg/${spgs.spgId}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: spgs.spgName + reload + reLoadPages,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setSpgs({
                    spgId: data.body.spgId,
                    companySpgId: -1,
                    compSpgId: -1,
                    spgName: data.body.spgName,
                });
                setSpgName(data.body.spgName);
                setSpgNameEn(data.body.spgNameEnglish);
                Elecinfo(data.body.spgId);
                spgGroups(data.body);
                setReloadPages(false);
                setIsActive(data.body.isActive);
            }
        }
        setRecoilIsLoadingBox(false);
    }, [data, reload, reLoadPages]);
    const Elecinfo = (spgId) => __awaiter(this, void 0, void 0, function* () {
        let data = null;
        data = yield HTTPUTIL.PromiseHttp({
            httpMethod: "GET",
            appPath: `/product/spg/${spgId}/elecinfos`,
            appQuery: {},
            userToken: userInfo.loginInfo.token,
        });
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setElecinfo(data.body.map((item, idx) => (Object.assign(Object.assign({}, item), { rowNum: idx + 1 }))));
            }
            else {
            }
        }
    });
    const spgGroups = (item) => __awaiter(this, void 0, void 0, function* () {
        let data = null;
        data = yield HTTPUTIL.PromiseHttp({
            httpMethod: "GET",
            appPath: `/product/spggroups`,
            appQuery: {},
            userToken: userInfo.loginInfo.token,
        });
        if (data) {
            if (data.codeNum == CONST.API_200) {
                if (item.spgGroup) {
                    setSpgGroup(item.spgGroup);
                }
                setSpgGroupItem(data.body);
            }
            else {
            }
        }
    });
    //  설비 유형명
    function onChangeSpg(e) {
        setErrorList(errorList.filter((err) => err.field !== "spgName"));
        setSpgName(e.target.value);
    }
    function onChangeSpgEn(e) {
        setErrorList(errorList.filter((err) => err.field !== "spgNameEnglish"));
        setSpgNameEn(e.target.value);
    }
    // elecInfo add
    function ElecInfoAdd(e) {
        if (elecinfo.length < 30) {
            let val = {
                dtoNo: elecinfo.length + 1,
                rowNum: elecinfo.length + 1,
                name: "",
                nameEnglish: "",
                unit: [""],
                unitEn: [""],
                isRequired: false,
                type: 1,
                selectedUnit: null,
            };
            setElecinfo([...elecinfo, val]);
        }
        else {
            setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, divTag: "초과 되었습니다." }));
            CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
        }
    }
    // elec Info delete
    function ElecInfoDelete(list, index) {
        if (list.elecInfoId > 0) {
            ElecInfoDel(list);
        }
        else {
            setElecinfo(elecinfo.filter((_, idx) => idx !== index));
        }
    }
    // elec info name
    function ElecInfoName(e, index) {
        // setErrorList(errorList.filter((err) => (err.field !== "checkitemRef")))
        setElecinfo(elecinfo.map((smenu, idx) => (idx === index ? Object.assign(Object.assign({}, smenu), { name: e.target.value }) : smenu)));
    }
    // elec info name
    function ElecInfoNameEn(e, index) {
        // setErrorList(errorList.filter((err) => (err.field !== "checkitemRef")))
        setElecinfo(elecinfo.map((smenu, idx) => (idx === index ? Object.assign(Object.assign({}, smenu), { nameEnglish: e.target.value }) : smenu)));
    }
    // elec info unit
    function ElecInfoUnit(e, index) {
        // setErrorList(errorList.filter((err) => (err.field !== "checkitemRef")))
        const { value } = e.target;
        const unitList = value.split(",").map((item) => item.trim());
        setElecinfo(elecinfo.map((smenu, idx) => (idx === index ? Object.assign(Object.assign({}, smenu), { unit: unitList }) : smenu)));
    }
    // elec info unitEn
    function ElecInfoUnitEn(e, index) {
        // setErrorList(errorList.filter((err) => (err.field !== "checkitemRef")))
        const { value } = e.target;
        const unitList = value.split(",").map((item) => item.trim());
        setElecinfo(elecinfo.map((smenu, idx) => (idx === index ? Object.assign(Object.assign({}, smenu), { unitEn: unitList }) : smenu)));
    }
    // elec info selectedUnit
    function ElecInfoSelectedUnit(e, index) {
        // setErrorList(errorList.filter((err) => (err.field !== "checkitemRef")))
        const { value } = e.target;
        const unitList = value.split(",").map((item) => item.trim());
        setElecinfo(elecinfo.map((smenu, idx) => idx === index ? Object.assign(Object.assign({}, smenu), { selectedUnit: value.length > 0 ? unitList : null }) : smenu));
    }
    // elec info check
    function EleInfoCheked(e, index) {
        // setErrorList(errorList.filter((err) => (err.field !== "checkitemRef")))
        setElecinfo(elecinfo.map((smenu, idx) => (idx === index ? Object.assign(Object.assign({}, smenu), { isRequired: e.target.checked }) : smenu)));
    }
    // elec info radio
    function EleInfoRadio(value, index) {
        // setErrorList(errorList.filter((err) => (err.field !== "checkitemRef")))
        setElecinfo(elecinfo.map((smenu, idx) => (idx === index ? Object.assign(Object.assign({}, smenu), { type: value }) : smenu)));
    }
    // 관련 설비 유형
    const spgGrouSelect = (item) => {
        setSpgGroup(item);
    };
    // 설비 유형 수정
    function onClickSaved(e) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            setRecoilIsLoadingBox(true);
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/product/spg/${spgs.spgId}`,
                appQuery: {
                    spgName: spgName,
                    spgNameEnglish: spgNameEn,
                    spgGroupId: spgGroup ? spgGroup.id : null,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    ElecInfoEidt(data.body);
                }
                else {
                    if (data.body.errorList.filter((err) => err.field == "spgName")) {
                        setErrorList(data.body.errorList);
                    }
                    else {
                        setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, divTag: data.body.errorList.map((err) => err.msg) }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                    setRecoilIsLoadingBox(false);
                }
            }
        });
    }
    // elec info 등록
    function ElecInfoCeatre(info, successEidt, failEidt) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            var success = [];
            var fail = [];
            for (let i = 0; i < elecinfo.filter((elec) => elec.dtoNo).length; i++) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "POST",
                    appPath: "/product/spg/elecinfo",
                    appQuery: {
                        spgId: info.spgId,
                        name: elecinfo.filter((elec) => elec.dtoNo)[i].name,
                        nameEnglish: elecinfo.filter((elec) => elec.dtoNo)[i].nameEnglish,
                        type: elecinfo.filter((elec) => elec.dtoNo)[i].type,
                        isRequired: elecinfo.filter((elec) => elec.dtoNo)[i].isRequired,
                        unit: elecinfo.filter((elec) => elec.dtoNo)[i].unit,
                        unitEn: elecinfo.filter((elec) => elec.dtoNo)[i].unitEn,
                        selectedUnit: elecinfo.filter((elec) => elec.dtoNo)[i].selectedUnit,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        var val = {
                            item: data.body,
                            index: elecinfo.filter((elec) => elec.dtoNo)[i].rowNum,
                        };
                        success.push(val);
                    }
                    else {
                        var val = {
                            item: data.errorList,
                            index: elecinfo.filter((elec) => elec.dtoNo)[i].rowNum,
                        };
                        fail.push(val);
                    }
                }
            }
            if (data) {
                if (fail.length <= 0) {
                    setRecoilIsLoadingBox(false);
                    setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, divTag: t("라벨.기본설비유형이수정되었습니다"), pTag: {
                            p1: failEidt.length > 0 && `수정 성공 항목[${successEidt.map((item) => item.index)}] 입니다.`,
                            p2: failEidt.length > 0 && `수정 실패 항목[${failEidt.map((item) => item.index)}] 입니다.`,
                        }, callBack: () => {
                            setReload(true);
                            setCheckSheet({
                                sheetType: checksheetName[0],
                                spgName: info.spgName,
                            });
                            setSpgs({
                                spgId: info.spgId,
                                compSpgId: -1,
                                companySpgId: -1,
                                spgName: info.spgName,
                            });
                            setWorkMode("READ");
                            setReload(false);
                            setRecoilIsLoadingBox(false);
                            CUTIL.jsclose_Popup(CONST.POP_ALERT);
                        } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
                else {
                    setRecoilIsLoadingBox(false);
                    setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, pTag: {
                            p1: `수정 성공 항목[${successEidt.map((item) => item.index)},${success.map((item) => item.index)}] 입니다.`,
                            p2: `수정 실패 항목[${failEidt.map((item) => item.index)},${fail.map((item) => item.index)}] 입니다.`,
                        }, callBack: () => {
                            setReload(true);
                            setCheckSheet({
                                sheetType: checksheetName[0],
                                spgName: info.spgName,
                            });
                            setSpgs({
                                spgId: info.spgId,
                                compSpgId: -1,
                                companySpgId: -1,
                                spgName: info.spgName,
                            });
                            setWorkMode("READ");
                            setReload(false);
                            CUTIL.jsclose_Popup(CONST.POP_ALERT);
                        } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    //elec info 수정
    function ElecInfoEidt(info) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = [];
            var success = [];
            var fail = [];
            for (let i = 0; i < elecinfo.filter((elec) => elec.elecInfoId).length; i++) {
                data = yield HTTPUTIL.PromiseHttp({
                    httpMethod: "PUT",
                    appPath: `/product/spg/elecinfo/${elecinfo[i].elecInfoId}`,
                    appQuery: {
                        name: elecinfo.filter((elec) => elec.elecInfoId)[i].name,
                        nameEnglish: elecinfo.filter((elec) => elec.elecInfoId)[i].nameEnglish,
                        isRequired: elecinfo.filter((elec) => elec.elecInfoId)[i].isRequired,
                        type: elecinfo.filter((elec) => elec.elecInfoId)[i].type,
                        unit: elecinfo.filter((elec) => elec.elecInfoId)[i].unit,
                        unitEn: elecinfo.filter((elec) => elec.elecInfoId)[i].unitEn,
                        selectedUnit: elecinfo.filter((elec) => elec.elecInfoId)[i].selectedUnit,
                    },
                    userToken: userInfo.loginInfo.token,
                });
                if (data) {
                    if (data.codeNum == CONST.API_200) {
                        var val = {
                            item: data.body,
                            index: elecinfo.filter((elec) => elec.elecInfoId)[i].rowNum,
                        };
                        success.push(val);
                    }
                    else {
                        var val = {
                            item: data.errorList,
                            index: elecinfo.filter((elec) => elec.elecInfoId)[i].rowNum,
                        };
                        fail.push(val);
                    }
                }
            }
            if (data) {
                if (fail.length <= 0) {
                    if (elecinfo.filter((elec) => elec.dtoNo).length > 0) {
                        ElecInfoCeatre(info, success, fail);
                    }
                    else {
                        setRecoilIsLoadingBox(false);
                        setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, divTag: t("라벨.기본설비유형이수정되었습니다"), callBack: () => {
                                setReload(true);
                                setCheckSheet({
                                    sheetType: checksheetName[0],
                                    spgName: info.spgName,
                                });
                                setSpgs({
                                    spgId: info.spgId,
                                    compSpgId: -1,
                                    companySpgId: -1,
                                    spgName: info.spgName,
                                });
                                setWorkMode("READ");
                                setReload(false);
                                CUTIL.jsclose_Popup(CONST.POP_ALERT);
                            } }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
                else {
                    if (elecinfo.filter((elec) => elec.dtoNo).length > 0) {
                        ElecInfoCeatre(info, success, fail);
                    }
                    else {
                        setRecoilIsLoadingBox(false);
                        setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_ERROR, pTag: {
                                p1: `수정 성공 항목[${success.map((item) => item.index)}] 입니다.`,
                                p2: `수정 실패 항목[${fail.map((item) => item.index)}] 입니다.`,
                            }, callBack: () => {
                                setReload(true);
                                setCheckSheet({
                                    sheetType: checksheetName[0],
                                    spgName: info.spgName,
                                });
                                setSpgs({
                                    spgId: info.spgId,
                                    compSpgId: -1,
                                    companySpgId: -1,
                                    spgName: info.spgName,
                                });
                                setWorkMode("READ");
                                setReload(false);
                                CUTIL.jsclose_Popup(CONST.POP_ALERT);
                            } }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                }
            }
        });
    }
    //elec info 삭제
    function ElecInfoDel(info) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "DELETE",
                appPath: `/product/spg/elecinfo/${info.elecInfoId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setElecinfo(elecinfo.filter((item) => item.elecInfoId !== info.elecInfoId));
                    setRecoilIsLoadingBox(false);
                }
                else {
                    /*     let msg =data.errorList.map((err) => ({ ...err, no: i + 1 })) */
                }
            }
        });
    }
    // 취소
    function onClickclose(e) {
        setReload(true);
        setWorkMode("READ");
        setReload(false);
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "content-wrap" }, { children: [_jsx("div", Object.assign({ className: "box__header brd-bottom-0" }, { children: _jsxs("h2", Object.assign({ className: "box__title" }, { children: [spgName, " ", t("라벨.수정")] })) })), _jsx("div", Object.assign({ className: "box__body" }, { children: _jsx("div", Object.assign({ className: "content__info" }, { children: _jsxs("ul", { children: [_jsxs("li", { children: [_jsxs("div", Object.assign({ className: "flex-row center" }, { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.설비유형명") })), _jsxs("div", Object.assign({ className: "txt" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.텍스트입력"), className: `w254 ${errorList.filter((err) => err.field === "spgName").length > 0 ? " input-error" : ""}`, value: spgName, onChange: (e) => onChangeSpg(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "spgName").map((err) => err.msg) }))] }))] })), _jsxs("div", Object.assign({ className: "flex-row center ml-80" }, { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.설비유형영문명") })), _jsxs("div", Object.assign({ className: "txt" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.텍스트입력"), className: `w254 ${errorList.filter((err) => err.field === "spgNameEnglish").length > 0 ? " input-error" : ""}`, value: spgNameEn, onChange: (e) => onChangeSpgEn(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "spgNameEnglish").map((err) => err.msg) }))] }))] })), _jsxs("div", Object.assign({ className: "flex-row center ml-80" }, { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: "\uAD00\uB828 \uC124\uBE44\uC720\uD615" })), _jsxs("div", Object.assign({ className: "select group w280", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: spgGroup ? spgGroup.spgGroupName : "없음" })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option", onClick: (e) => spgGrouSelect(null) }, { children: "\uC5C6\uC74C" })), spgGroupItem &&
                                                                    spgGroupItem.map((list, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => spgGrouSelect(list) }, { children: list.spgGroupName }), "spgGroupList_" + idx.toString())))] })] }))] }))] }), _jsxs("li", Object.assign({ className: "mb-24" }, { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.ElecInfo설정") })), _jsx("div", Object.assign({ className: "tbl-list txt p-4" }, { children: _jsxs("table", Object.assign({ summary: "No., Elec Info \uBA85,\uB2E8\uC704,\uC0AD\uC81C \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C Elec Info \uC124\uC815 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "Elec Info \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "4%" } }), _jsx("col", { style: { width: "11%" } }), _jsx("col", { style: { width: "11%" } }), _jsx("col", { style: { width: "11%" } }), _jsx("col", { style: { width: "17%" } }), _jsx("col", { style: { width: "15%" } }), _jsx("col", { style: { width: "15%" } }), _jsx("col", { style: { width: "12%" } }), _jsx("col", { style: { width: "4%" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col", className: "pl-24" }, { children: "No." })), _jsx("th", Object.assign({ scope: "col" }, { children: t("라벨.ElecInfo명") })), _jsx("th", Object.assign({ scope: "col" }, { children: t("라벨.영문명") })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: "\uAD50\uCCB4\uBD84\uC11D \uD544\uC218\uC5EC\uBD80" })), _jsx("th", Object.assign({ scope: "col" }, { children: "Elec Info \uC785\uB825 \uBC29\uC2DD" })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uC785\uB825 \uC138\uBD80 \uC124\uC815" })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uC785\uB825 \uC138\uBD80 \uC124\uC815 (\uC601\uBB38)" })), _jsx("th", Object.assign({ scope: "col" }, { children: "\uC635\uC158 \uB9E4\uD551 \uC815\uBCF4" })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: t("라벨.삭제") }))] }) }), _jsxs("tbody", { children: [elecinfo.length > 0 ? (elecinfo.map((list, idx) => (_jsxs("tr", { children: [_jsx("td", Object.assign({ className: "pl-12" }, { children: idx + 1 })), _jsx("td", { children: _jsx("input", { type: "text", placeholder: `${t("라벨.예시")} 전력전압`, value: list.name, onChange: (e) => ElecInfoName(e, idx) }) }), _jsx("td", { children: _jsx("input", { type: "text", placeholder: `${t("라벨.예시")} PowerVoltage`, value: list.nameEnglish, onChange: (e) => ElecInfoNameEn(e, idx) }) }), _jsxs("td", Object.assign({ className: "txt-center" }, { children: [_jsx("input", { type: "checkbox", id: "ch" + idx, name: "ch", checked: list.isRequired ? true : false, onChange: (e) => EleInfoCheked(e, idx) }), _jsx("label", Object.assign({ htmlFor: "ch" + idx, className: "check-only-16" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC120\uD0DD" })) }))] })), _jsx("td", { children: _jsxs("div", Object.assign({ className: "radioBox flex-row center mt-2" }, { children: [_jsxs("label", Object.assign({ htmlFor: "rd1_" + idx }, { children: [_jsx("input", { type: "radio", id: "rd1_" + idx, name: "rd1_" + idx, checked: list.type == 1 ? true : false, value: list.type, onChange: (e) => EleInfoRadio(1, idx) }), "\uC9C1\uC811\uC791\uC131\uD615"] })), _jsxs("label", Object.assign({ htmlFor: "rd2_" + idx, className: "ml-8" }, { children: [_jsx("input", { type: "radio", id: "rd2_" + idx, name: "rd2_" + idx, checked: list.type == 2 ? true : false, onChange: (e) => EleInfoRadio(2, idx) }), "\uC635\uC158\uC120\uD0DD\uD615"] }))] })) }), list.type == 2 ? (_jsx("td", { children: _jsx("input", { type: "text", placeholder: "\uC635\uC158 \uAC12\uC744 \uAD6C\uBD84\uC790 \u2018,\u2019 \uB85C \uAD6C\uBD84\uD558\uC5EC \uC785\uB825\uD558\uC138\uC694.", value: list.unit, onChange: (e) => ElecInfoUnit(e, idx) }) })) : (_jsx("td", { children: _jsx("input", { type: "text", placeholder: `${t("라벨.예시")} kV`, value: list.unit, onChange: (e) => ElecInfoUnit(e, idx) }) })), _jsx("td", { children: _jsx("input", { type: "text", placeholder: "\uC601\uBB38\uC73C\uB85C \uC785\uB825\uD558\uC138\uC694.", value: list.unitEn, onChange: (e) => ElecInfoUnitEn(e, idx) }) }), _jsx("td", { children: list.type < 2 && (_jsx("input", { type: "text", placeholder: "\uB9E4\uD551\uD560 \uC635\uC158 \uAC12 \uC785\uB825", value: list.selectedUnit || "", onChange: (e) => ElecInfoSelectedUnit(e, idx) })) }), _jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: "btn btn-delete-gr", onClick: (e) => ElecInfoDelete(list, idx) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC0AD\uC81C" })) })) })] }, "elecInfo_" + idx.toString())))) : (_jsx("tr", { children: _jsxs("td", Object.assign({ className: "txt-info", colSpan: 9 }, { children: ["* ", t("라벨.등록된내용이없습니다추가버튼을눌러ElecInfo를설정해주세요")] })) })), _jsx("tr", { children: _jsx("td", Object.assign({ colSpan: 9, className: "bg-no ph-8 pl-24" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-add-wide", onClick: (e) => ElecInfoAdd(e) }, { children: _jsx("span", { children: t("라벨.추가") }) })) })) })] })] })) }))] })), _jsx("li", { children: _jsxs("div", Object.assign({ className: "btn__wrap" }, { children: [_jsx("button", Object.assign({ type: "button", className: "btn-basic bg-gray", onClick: (e) => onClickclose(e) }, { children: _jsx("span", { children: t("라벨.취소") }) })), _jsx("button", Object.assign({ type: "button", className: "btn-basic ", onClick: (e) => onClickSaved(e) }, { children: _jsx("span", { children: t("라벨.저장") }) }))] })) })] }) })) }))] })) }));
}
export default SpgDefalutUpdate;
